module.exports = __webpack_public_path__ + "static/img/disease_banner.bf78615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/disease_banner.png
// module id = 6FIg
// module chunks = 90